















































































































































































import { ParksAPI } from '@/apis/parks.api';
import { IPark, IParkWeekday } from '@/models/IPark.model';
import { Component, Prop, Vue } from 'vue-property-decorator';


const hoursPublic = {
       hour600am_730am: false,
       hour800am_930am: false,
       hour1000am_1130am: false,
       hour1200am_0130pm: false,

       hour200pm_330pm: false,
       hour400pm_530pm: false,
}

const hoursSchool = {

       hour600am_700am: false,
       hour800am_900am: false,
       hour1000am_1100am: false,
       hour1200am_0100pm: false,

       hour0300pm_0400pm: false,
       hour0500pm_0600pm: false,
}

@Component({
    components: {},
})
export default class TabParksDeleteModalView extends Vue {

    public name = '';
    public logo = 'https://www.flaticon.com/svg/static/icons/svg/896/896008.svg';
    public capacity = 0;
    public showDialog = false;

    open(){
        this.name = '';
        this.capacity = 0 ;
        this.showDialog = true
    }

   public monday = { ...hoursPublic , ...hoursSchool };
   public tuesday = { ...hoursPublic , ...hoursSchool };
   public wednesday = { ...hoursPublic , ...hoursSchool };
   public thursday = { ...hoursPublic , ...hoursSchool };
   public friday = { ...hoursPublic , ...hoursSchool };
   public saturday = { ...hoursPublic , ...hoursSchool };
   public sunday = { ...hoursPublic , ...hoursSchool };

   public setMondayToogle($hour: string){
       this.monday[$hour] = !this.monday[$hour] ;
   }
   public setTuesdayToogle($hour: string){
       this.tuesday[$hour] = !this.tuesday[$hour] ;
   }
   public setWednesdayToogle($hour: string){
       this.wednesday[$hour] = !this.wednesday[$hour] ;
   }
   public setThursdayToogle($hour: string){
       this.thursday[$hour] = !this.thursday[$hour] ;
   }
   public setFridayToogle($hour: string){
       this.friday[$hour] = !this.friday[$hour] ;
   }
   public setSaturdayToogle($hour: string){
       this.saturday[$hour] = !this.saturday[$hour] ;
   }
   public setSundayToogle($hour: string){
       this.sunday[$hour] = !this.sunday[$hour] ;
   }
   public getSchedules(day){
        const schedules: IParkWeekday[] = [];
        Object.keys(this[day]).forEach(hourKey => {
            const isEnabled = this[day][hourKey];
            const types = [
                !(Object.keys(hoursSchool).includes(hourKey) && this[day][hourKey]) ? 'PUBLIC' : '' ,
                  Object.keys(hoursSchool).includes(hourKey) && this[day][hourKey] ? 'SCHOOL': ''
            ].filter(type => type && type != '')


            if(isEnabled){
                schedules.push({
                    hour: hourKey,
                    aviableFor: types as any,
                    capacity: {
                        total: parseInt(this.capacity + '', 10),
                        busy: 0,
                    },
                })
            }
        });
       return schedules
   }


    public async save(){
        if(this.name && this.capacity){
            try{
                const payload : IPark= {
                      id: this.name.replace(/[^A-Z0-9]+/ig, "_"),
                      name: this.name,
                      logo: this.logo,
                      capacity: this.capacity,
                      weekdays: {
                          monday: this.getSchedules('monday'),
                          tuesday: this.getSchedules('tuesday'),
                          wednesday: this.getSchedules('wednesday'),
                          thursday: this.getSchedules('thursday'),
                          friday: this.getSchedules('friday'),
                          saturday: this.getSchedules('saturday'),
                          sunday: this.getSchedules('sunday'),
                      }
                };
                
                const parkApi =  new ParksAPI();
                const park = await parkApi.post(payload);

                this.$emit('save', park);
                this.showDialog = false;

            } catch(error){
                this.$swal('ERROR GUARDANDO PARQUE',JSON.stringify(error),'error')
            }
        } else {
            this.$swal('NOMBRE O CAPACIDAD INVALIDA','','success')
        }
    }
}
